import { render, staticRenderFns } from "./dialog-edit-select.vue?vue&type=template&id=156f3e10&scoped=true&"
import script from "./dialog-edit-select.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-select.vue?vue&type=script&lang=js&"
import style0 from "./dialog-edit-select.vue?vue&type=style&index=0&id=156f3e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f3e10",
  null
  
)

export default component.exports